import { FC, useEffect, useState, useRef } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { getShopifyProductList } from 'lowcode/apis/getShopifyProductList';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import styled from './index.module.scss';
import { products, IProductItem } from './config';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';

const ProductList: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.productlist');
    const [list, setList] = useState(products[locale] || products.eu);
    const swiperRef = useRef<any>(null);

    const variantIds = list?.map((item) => item.variantId);

    const initProductList = () => {
        getShopifyProductList(locale, variantIds).then((res) => {
            // 混入img productTitle price等参数
            const newList = list.map((item) => {
                const target = res.find((resItem: any) => resItem.variantId === item.variantId);
                return {
                    ...item,
                    img: target?.variantImg,
                    price: target?.price,
                    productTitle: target?.skuTitle,
                    compareAtPrice: target?.compareAtPrice,
                    detailLink: `https://${locale}.ecoflow.com/products/${target?.handle}?variant=${item.variantId}`,
                };
            });
            setList(newList);
        });
    };
    const handleClick = (item: IProductItem) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('productlist_btn')}_${item.productTitle}`,
        });
        window.open(item.detailLink, '_blank');
        // window.open(`https://${locale}.ecoflow.com/cart/${item.variantId}:1?channel=buy_button`, '_blank');
    };

    const handlePrev = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            list_name: t('productlist_title'),
            button_name: 'Left switch',
        });
    };

    const handleNext = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            list_name: t('productlist_title'),
            button_name: 'Right switch',
        });
    };

    useEffect(() => {
        initProductList();
    }, []);

    return (
        <div className={styled.ProductList} id="Products">
            <p className="title">{t('productlist_title')}</p>
            <div className="product_central">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    className="product_box"
                    modules={[Navigation]}
                    spaceBetween={30}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {list.map((item, index) => (
                        <SwiperSlide className="product_item" key={item.variantId + index}>
                            <span className="tips">{item.tips}</span>
                            <div className="product-top">
                                <EditorImg className="img" pc={item.img} alt={item.productTitle} />
                                <p className="name">{item.productTitle}</p>
                                <p className="desc">{item.desc}</p>
                            </div>
                            <div className="product-bottom">
                                <div className="save">
                                    <span>{item.save}</span>
                                </div>
                                <div className="product-desc">
                                    {item.descList.map((text, index) => {
                                        return (
                                            <div key={text} className="product-desc__item">
                                                <div className="item-title">{text}</div>
                                                <div className="item-desc">{item.subDescList[index]}</div>
                                            </div>
                                        );
                                    })}
                                </div>
                                <div className="price-line">
                                    <span className="price">{FormatMoneyLocal(item.price || 0, locale)}</span>
                                    <span className="compare-price">
                                        {Number(item.compareAtPrice) > Number(item.price) ? FormatMoneyLocal(item.compareAtPrice || 0, locale) : null}
                                    </span>
                                    {/* <span className="price-desc">{item.priceDesc}</span> */}
                                </div>
                                <EditorLink className="btn" onClick={() => handleClick(item)}>
                                    {t('productlist_btn')}
                                </EditorLink>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} />
                </Swiper>
            </div>
        </div>
    );
};

export default ProductList;
